import React, { useEffect, useState } from "react";
import { Button, Form, Spinner, Toast, Modal } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import API from "../api";

export default function HandicapGenerator() {
  const { user } = useAuth();
  const [weeks, setWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const fetchWeeks = async () => {
      try {
        const res = await API.get(`/league/${user.leagueid}/weeks`);
        setWeeks(res.data);
      } catch (err) {
        console.error("Failed to fetch weeks", err);
      }
    };
    if (user?.leagueid) fetchWeeks();
  }, [user?.leagueid]);

  const handleGenerate = async () => {
    if (!selectedWeek) return;
    setLoading(true);
    try {
      await API.post(`/league/${user.leagueid}/handicaps/calculate/${selectedWeek}`);
      setShowSuccess(true);
    } catch (err) {
      console.error("Failed to generate handicaps", err);
      setErrorMsg(err.response?.data?.message || "Failed to generate handicaps.");
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h4>Generate Averages and Handicaps</h4>

      <Form.Group className="mb-3 mt-3">
        <Form.Label>Select Week</Form.Label>
        <Form.Select
          value={selectedWeek}
          onChange={(e) => setSelectedWeek(e.target.value)}
        >
          <option value="">-- Select Week --</option>
          {weeks.map((w) => (
            <option key={w.week_number} value={w.week_number}>
              {w.week_number} - {w.date}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Button
        variant="primary"
        disabled={!selectedWeek || loading}
        onClick={handleGenerate}
      >
        {loading ? "Generating..." : "Generate AVG + HDCP"}
      </Button>

      {/* Success Toast */}
      <Toast
        show={showSuccess}
        onClose={() => setShowSuccess(false)}
        delay={3000}
        autohide
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          minWidth: "200px",
        }}
      >
        <Toast.Body>Handicaps generated successfully!</Toast.Body>
      </Toast>

      {/* Error Modal */}
      <Modal show={showError} onHide={() => setShowError(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMsg}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowError(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
